// src/pages/admin/Education/ViewScholarshipApplications.jsx
import React from 'react';
import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaGraduationCap,
  FaBuilding,
  FaClock,
  FaDownload,
} from 'react-icons/fa';
import { useGetScholarshipApplicationsQuery } from '../../redux/services/scholarshipsService/scholarships.Service';

function ViewScholarshipApplications({ data }) {
  const { data: applicationsData, isLoading, isError, refetch } = useGetScholarshipApplicationsQuery(
    data?.scholarship_id,
    { skip: !data?.scholarship_id }
  );

  const applications = applicationsData?.data || [];

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'pending': { class: 'badge bg-warning', label: 'Pending' },
      'shortlisted': { class: 'badge bg-info', label: 'Shortlisted' },
      'approved': { class: 'badge bg-success', label: 'Approved' },
      'rejected': { class: 'badge bg-danger', label: 'Rejected' },
    };
    const statusInfo = statusMap[status] || statusMap['pending'];
    return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
  };

  if (isLoading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading applications...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-4 text-danger">
        <p>Failed to load applications</p>
        <button className="btn btn-sm btn-primary" onClick={() => refetch()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="view-applications-container">
      <div className="mb-3">
        <h5 className="fw-bold">{data?.title}</h5>
        <p className="text-muted">Total Applications: <strong>{applications.length}</strong></p>
      </div>

      {applications.length === 0 ? (
        <div className="text-center py-4">
          <FaUser size={40} className="text-muted" />
          <p className="mt-2 text-muted">No applications yet</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Education</th>
                <th>Institution</th>
                <th>Status</th>
                <th>Applied</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((app, index) => (
                <tr key={app.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="fw-semibold">{app.full_name}</div>
                    {app.documents_path && (
                      <a 
                        href={app.documents_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary small d-block"
                      >
                        <FaDownload className="me-1" /> Documents
                      </a>
                    )}
                  </td>
                  <td>{app.email}</td>
                  <td>{app.phone}</td>
                  <td>{app.education_level || 'N/A'}</td>
                  <td>{app.institution_name || 'N/A'}</td>
                  <td>{getStatusBadge(app.status)}</td>
                  <td>{formatDate(app.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ViewScholarshipApplications;